<div class="row text-center">
    <div class="col">
      <h1 class="title-copy">
        {{ "ACCOUNT_ACTIVATION" | translate }}
      </h1>
      <div [ngClass]="{ 'title-width': !isAcmic }">
        {{ "ACCOUNT_ACTIVATION_DESC" | translate }}
      </div>
      <form
        [formGroup]="activateEmailForm"
        name="activateEmailForm"
        (ngSubmit)="activateEmailForm.valid && activeEmail()"
        class="s-signUpForm"
      >
        <div class="input">
          <mapfre-validation
            [input]="inputs[0]"
            [form]="activateEmailForm"
          ></mapfre-validation>
        </div>
        <div class="row group-button text-center">
          <div class="col">
            <mapfre-button
              [additionalClasses]="'basic primary large-btn'"
              [disabledValue]="activateEmailForm.valid"
              [inputType]="'submit'"
              [translateValue]="'CONTINUE' | translate"
            ></mapfre-button>
          </div>
        </div>
        <div class="row text-center margin-top mt24">
            <div class="col">
              <ng-container *ngIf="isAcmic else backButtonForMA">
                  <mapfre-button
                  (click)="goBack()"
                  additionalClasses="link-button small-btn blue-link no-margin button-border-red"
                  [customIcon]="'assets/img/icons/back-arrow.png'"
                  [backIcon]="'assets/img/icons/back-arrow-red.png'"
                  [iconClasses]="'align-middle'"
                  [showIconsCustom]="true"
                  >  {{ 'BACK' | translate }}
                  </mapfre-button>
              </ng-container>
              <ng-template #backButtonForMA>
                <mapfre-button
                  (click)="goBack()"
                  additionalClasses="link-button small-btn red-link no-margin button-border-red"
                  [customIcon]="'assets/img/icons/back-arrow.png'"
                  [backIcon]="'assets/img/icons/back-arrow-red.png'"
                  [iconClasses]="'align-middle'"
                  [showIconsCustom]="true"
                  >  {{ 'BACK' | translate }}
                  </mapfre-button>
              </ng-template>
            </div>
        </div>
      </form>
    </div>
  </div>
  